export default [
  {
    path: '/client/users',
    meta: { auth: 'client' },
    component: () => import(/* webpackChunkName: "client-users" */ "@/views/client/Users.vue")
  },
]
